import { render, staticRenderFns } from "./CancelBookingDialog.vue?vue&type=template&id=985a8066&"
import script from "./CancelBookingDialog.vue?vue&type=script&lang=js&"
export * from "./CancelBookingDialog.vue?vue&type=script&lang=js&"
import style0 from "./CancelBookingDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports